import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CarouselModule, OwlOptions } from 'ngx-owl-carousel-o';

@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrl: './slider.component.scss',
  imports: [CommonModule, CarouselModule, RouterLink],
})
export class SliderComponent {
  sliderData = [
    {
      heading:
        '“Security is mostly superstition. Avoiding danger is no safer in the long run, than outright exposure. Life is either a daring adventure or nothing”',
      name: '~ Helen Kelle',
    },
    {
      heading:
        '“Security is mostly superstition. Avoiding danger is no safer in the long run, than outright exposure. Life is either a daring adventure or nothing”',
      name: '~ Helen Kelle 2',
    },
    {
      heading:
        '“Security is mostly superstition. Avoiding danger is no safer in the long run, than outright exposure. Life is either a daring adventure or nothing”',
      name: '~ Helen Kelle 3',
    },
  ];
  customOptions: OwlOptions = {
    loop: false,
    autoplay: false,
    center: false,
    dots: false,
    margin: 20,
    nav: true,
    navText: [
      '<img src="../../../assets/images/ic_arrow-slide.svg" class="arrow left-arrow">',
      '<img src="../../../assets/images/ic_arrow-slide.svg" class="arrow right-arrow">',
    ],
    autoHeight: false,
    autoWidth: false,
    responsive: {
      0: {
        items: 1,
      },
      600: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };

  constructor() {}

  ngOnInit(): void {}
}
